export default {
  namespaced: true,
  employees_units: {
    title: 'Employee assignments | Employee Assignment',
    schedules: 'Schedules',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    start: 'Start',
    end: 'End',
    startRequired: 'Start required',
    endRequired: 'End required'
  }
}
